export const GET_DISTRICTS_AJAX_SUCCESS = "GET_DISTRICTS_AJAX_SUCCESS";